import { AddressType } from 'components/Forms/Address/types';
import { Nullable } from 'utils/types';

export type AddressFieldsValueMethod = (addressPrefix: string, address: AddressType | any) => void;

export const populateAddressHandler = (setFieldValue: any): AddressFieldsValueMethod => (
  addressPrefix: string,
  address: AddressType | any,
) => {
  const prefix = addressPrefix ? `${addressPrefix}.` : '';

  Object.keys(address).forEach((addressKeyName: string) => {
    setFieldValue(`${prefix}${addressKeyName}`, address[addressKeyName]);
  });
};

// Address form populate that concatenates the flat and building numbers
export const populateAddressHandlerNumberConcat = (setFieldValue: any): AddressFieldsValueMethod => (
  addressPrefix: string,
  address: AddressType | any,
) => {
  const prefix = addressPrefix ? `${addressPrefix}.` : '';
  const conCatFields = ['flatNumber', 'buildingNumber'];
  const conCatValues = conCatFields.map((key: string) => {
    return address[key];
  });

  setFieldValue(`${prefix}buildingNumber`, conCatValues.filter((item: any) => !!item).join(', '));

  Object.keys(address).forEach((addressKeyName: string) => {
    if (!conCatFields.includes(addressKeyName)) {
      setFieldValue(`${prefix}${addressKeyName}`, address[addressKeyName]);
    }
  });
};

export const areAddressesEqual = (addresses: AddressType[]) => {
  const serializeAddress = (address: AddressType) => {
    const serializedObject = [
      address.flatNumber,
      address.buildingName,
      address.buildingNumber,
      address.street,
      address.city,
      address.postcode,
      address.county,
    ].reduce((prevValue: Nullable<string>, value: Nullable<string>) => {
      const v: string = value || '';
      return prevValue + v.split(' ').join('');
    }, '');

    return serializedObject;
  };

  const [result] = addresses.reduce(
    ([_, prevAddress], address) => {
      return typeof prevAddress === 'object'
        ? [serializeAddress(prevAddress) === serializeAddress(address), address]
        : [false, address];
    },
    [false, addresses[0]],
  );
  return result;
};
